import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const { theme } = useTheme();
  return (
    <footer className="glass-frosted border-t border-subtle">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1 space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg flex items-center justify-center">
                <img src={theme === 'dark' ? '/logo-dark.png' : '/logo-light.png'} alt="Forge Studio Logo" className="w-full h-full object-contain rounded-lg transition-opacity duration-300" />
              </div>
              <span className="font-bold text-lg text-foreground-primary">Forge</span>
            </div>
            <p className="text-sm text-foreground-secondary">
              The Complete Platform for Robotics.
            </p>
            <p className="text-xs text-foreground-secondary">
              A product by<br />Vinayak Robotics LLP
            </p>
            <div className="flex gap-4 mt-4">
              <a
                href="https://www.linkedin.com/company/vinayakrobotics/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-smooth hover:scale-110 text-foreground-secondary hover:text-orange-400"
                aria-label="LinkedIn"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect width="4" height="12" x="2" y="9"/><circle cx="4" cy="4" r="2"/></svg>
              </a>
              <a
                href="https://www.instagram.com/vinayak_robotics/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-smooth hover:scale-110 text-foreground-secondary hover:text-orange-400"
                aria-label="Instagram"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
              </a>
              <a
                href="https://www.youtube.com/@vinayakrobotics"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-smooth hover:scale-110 text-foreground-secondary hover:text-orange-400"
                aria-label="YouTube"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17"/><path d="m10 15 5-3-5-3z"/></svg>
              </a>
            </div>
          </div>

          {/* Software */}
          <div>
            <h3 className="text-foreground-primary font-semibold mb-4 text-sm">Software</h3>
            <ul className="space-y-2">
              <li><Link to="/download" className="text-sm text-foreground-secondary hover:text-orange-400 transition-smooth">Forge Studio</Link></li>
              <li><span className="text-sm text-foreground-muted">Forge Cloud <span className="text-[10px]">(soon)</span></span></li>
            </ul>
          </div>

          {/* Hardware */}
          <div>
            <h3 className="text-foreground-primary font-semibold mb-4 text-sm">Hardware</h3>
            <ul className="space-y-2">
              <li><span className="text-sm text-foreground-muted">Sensors & LiDAR <span className="text-[10px]">(soon)</span></span></li>
              <li><span className="text-sm text-foreground-muted">Dev Boards <span className="text-[10px]">(soon)</span></span></li>
              <li><span className="text-sm text-foreground-muted">Forge Certified <span className="text-[10px]">(soon)</span></span></li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-foreground-primary font-semibold mb-4 text-sm">Solutions</h3>
            <ul className="space-y-2">
              <li><span className="text-sm text-foreground-secondary">Hobbyists & Students</span></li>
              <li><span className="text-sm text-foreground-secondary">Startups</span></li>
              <li><Link to="/pricing" className="text-sm text-foreground-secondary hover:text-orange-400 transition-smooth">Enterprise</Link></li>
              <li><Link to="/pricing" className="text-sm text-foreground-secondary hover:text-orange-400 transition-smooth">Pricing</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-foreground-primary font-semibold mb-4 text-sm">Company</h3>
            <ul className="space-y-2">
              <li><a href="https://vinayakrobotics.com" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-secondary hover:text-orange-400 transition-smooth">Vinayak Robotics</a></li>
              <li><a href="https://vinayakrobotics.com/contact" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-secondary hover:text-orange-400 transition-smooth">Contact</a></li>
              <li><span className="text-sm text-foreground-muted">Documentation <span className="text-[10px]">(soon)</span></span></li>
              <li><a href="https://forums.vinayakrobotics.com" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-secondary hover:text-orange-400 transition-smooth">Forums</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-subtle mt-10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-foreground-secondary">
              &copy; {new Date().getFullYear()} Vinayak Robotics LLP. All rights reserved.
            </p>
            <div className="flex gap-6">
              <span className="text-xs text-foreground-secondary">Privacy Policy</span>
              <span className="text-xs text-foreground-secondary">Terms of Service</span>
              <span className="text-xs text-foreground-secondary">License (BUSL 1.1)</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
